import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { ref, onValue } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import InchargeLayout from './InchargeLayout';
import { FaFilePdf } from 'react-icons/fa';

const SocViewPassbook = () => {
    const navigate = useNavigate();
    const [passbookData, setPassbookData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const passbookRef = ref(db, 'ekamwatapzp/SocPassbooks'); // Node for Society Passbooks
        const unsubscribe = onValue(passbookRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setPassbookData(list);
            } else {
                setPassbookData([]);
            }
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const filteredData = passbookData.filter(item =>
        item.workName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.lotteryNo?.toString().includes(searchTerm)
    );

    return (
        <InchargeLayout>
            <div className="min-h-screen bg-[#f8f9fa] flex flex-col  p-8">
                {/* Header Section */}
                <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 px-2 text-[#344767]">
                    <h1 className="text-xl font-medium">पासबुक अपडेट</h1>
                    <div className="flex items-center text-sm font-medium text-gray-400 gap-2">
                        <span>सांगली जिल्हा परिषद</span>
                        <span>/</span>
                        <span className="text-gray-500 font-semibold">पासबुक अपडेट</span>
                    </div>
                </div>

                {/* Main Content Card */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-8 max-w-[100%]">

                    {/* Table Controls */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                        <div className="flex items-center rounded overflow-hidden shadow-sm border border-gray-300">
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Copy</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium border-r border-gray-500 transition-colors">Excel</button>
                            <button className="bg-[#6c757d] hover:bg-[#5a6268] text-white px-4 py-1.5 text-sm font-medium transition-colors">Print</button>
                        </div>

                        <div className="flex items-center gap-2">
                            <label className="text-sm font-medium text-gray-600">Search:</label>
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="border border-gray-300 rounded px-3 py-1.5 text-sm outline-none focus:ring-1 focus:ring-blue-400 focus:border-blue-400"
                            />
                        </div>
                    </div>

                    {/* Passbook Table */}
                    <div className="overflow-x-auto border border-gray-200 rounded text-[#344767]">
                        <table className="w-full text-left text-[13px] border-collapse bg-white">
                            <thead>
                                <tr className="bg-white border-b border-gray-200 font-bold divide-x divide-gray-100">
                                    <th className="px-3 py-4 w-12 text-center text-gray-800">Sr.No. <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 min-w-[300px] text-gray-800">कामाचे नाव <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">लॉटरी क्रमांक <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">कामाची किंमत <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">विभागाचे नाव <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">काम पूर्ण करण्याची मुदत <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">काम पुर्ण केल्याचा दिनांक <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">स्थिती <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                    <th className="px-3 py-4 text-gray-800">शेरा <span className="text-[9px] ml-0.5 text-gray-400">↑↓</span></th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-100">
                                {loading ? (
                                    <tr><td colSpan="9" className="text-center py-10 text-gray-400 italic">पासबुक डेटा लोड होत आहे...</td></tr>
                                ) : filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={item.id} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/20'} hover:bg-gray-100/50 transition-colors divide-x divide-gray-100`}>
                                            <td className="px-3 py-6 text-center font-medium">{index + 1}</td>
                                            <td className="px-3 py-6">
                                                <div className="flex flex-col gap-2">
                                                    <span className="font-medium text-gray-700 leading-snug">{item.workName}</span>
                                                    {item.docUrl && (
                                                        <FaFilePdf size={22} className="text-red-500 cursor-pointer hover:scale-110 transition-transform" title="डॉक्युमेंट पहा" />
                                                    )}
                                                </div>
                                            </td>
                                            <td className="px-3 py-6 font-medium">{item.lotteryNo || item.lotteryId || '-'}</td>
                                            <td className="px-3 py-6 font-bold">{item.amount || item.price || '0'}</td>
                                            <td className="px-3 py-6">{item.deptName || 'बांधकाम विभाग'}</td>
                                            <td className="px-3 py-6">{item.duration || '3 महिने'}</td>
                                            <td className="px-3 py-6">{item.completionDate || '-'}</td>
                                            <td className="px-3 py-6 font-bold text-amber-500">Pending</td>
                                            <td className="px-3 py-6"></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="px-6 py-12 text-center text-gray-500 font-medium italic">
                                            No data available in table
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Context */}
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mt-8 pb-4 text-sm text-gray-600">
                        <p>Showing {filteredData.length > 0 ? 1 : 0} to {filteredData.length} of {filteredData.length} entries</p>
                        <div className="flex shadow-sm rounded-md overflow-hidden border border-gray-200">
                            <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-r border-gray-200 transition-colors text-gray-500">Previous</button>
                            <button className="px-4 py-1.5 bg-indigo-600 text-white font-bold">{filteredData.length > 0 ? 1 : 0}</button>
                            <button className="px-4 py-1.5 bg-white hover:bg-gray-50 border-l border-gray-200 transition-colors text-gray-500">Next</button>
                        </div>
                    </div>

                </div>
            </div>
        </InchargeLayout>
    );
};

export default SocViewPassbook;
